import axios, { InternalAxiosRequestConfig } from 'axios';
import { firebaseAuth, firebaseAuthReady } from '@/services/firebase';
import { getAuthenticationInfoFromStorage } from '@/contexts/AuthContext/utils/getAuthenticationInfoFromStorage';

/**
 * Anexa as credenciais do admin em cada request:
 * - `Authorization: Bearer <Firebase ID token>` — identidade (renovado pelo SDK);
 * - `x-2fa-session: <token>` — prova do 2º fator (quando já logado).
 *
 * Use `params.removeJWT` para uma chamada sem Authorization (rotas públicas).
 */
axios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  await firebaseAuthReady;
  const user = firebaseAuth.currentUser;
  if (user) {
    const idToken = await user.getIdToken();
    config.headers.Authorization = `Bearer ${idToken}`;
  } else {
    delete config.headers.Authorization;
  }

  const session = getAuthenticationInfoFromStorage();
  if (session?.twofa_session) {
    config.headers['x-2fa-session'] = session.twofa_session;
  }

  if (config.params && config.params.removeJWT) {
    delete config.params.removeJWT;
    delete config.headers.Authorization;
  }

  return config;
});
